<template>
  <section class="private_wrap admin-hash-wrap" :style="dBHeight">
    <!-- <modals-container @updateCdValue="getCodeList" @updateCodeDesc="getCodeList" @deleteCode="getCodeList" @registCode="getCodeList"></modals-container> -->
    <div class="tab_ty1">
      <AuditTab :currentTab="3" />
      <div class="tab-content">
        
          <div class="tab_ty2">
            <AuditSubTab :currentTab="3" :currentTab2="4" />
            <div class="tab-content">
              <div class="admin-hash-tag">
                <div class="organization-area">
                  <HtagJobGroup
                      ref="org"
                      @selectNode="selectNode"
                  />
                </div>

                <div class="selected-area">
                  <div class="info-txt">
                    <!-- <button type="button" class="btn-primary-small">내려받기</button>
                    <button type="button" class="btn-primary-small">일괄등록</button> -->
                  </div>

                  <ul class="list-table">
                    <li>
                      <dl>
                        <dt>{{$i18nUtil.trans("message.HtagList.001","위치")}}</dt>
                        <dd v-if="jobGroupInfo != null">
                           {{jobGroupRoute}}
                        </dd>
                      </dl>
                    </li>
                    <li>
                      <dl>
                        <dt>{{$i18nUtil.trans("message.HtagList.002","카테고리명")}}</dt>
                        <dd>
                          <div class="input-box">
                            <input type="text" required="required" :placeholder="$i18nUtil.trans('message.HtagList.003','카테고리명 입력')" v-model="selectedCategoryName">
                            <button type="reset" class="input-txt-del" @click="selectedCategoryName = ''" >{{$i18nUtil.trans("message.HtagList.004","입력 삭제")}}</button>
                          </div>
                        </dd>
                      </dl>
                    </li>
                    <li>
                      <dl>
                        <dt>{{$i18nUtil.trans("message.HtagList.005","검색대상")}}</dt>
                        <dd>
                          <div class="radio-box">
                            <input type="radio" name="search" id="search1" value="1" v-model="searchCheck"><label for="search1">{{$i18nUtil.trans("message.HtagList.006","대상")}}</label> 
                            <input type="radio" name="search" id="search2" value="0" v-model="searchCheck"><label for="search2">{{$i18nUtil.trans("button.except","제외")}}</label>
                          </div>
                        </dd>
                      </dl>
                    </li>
                    <li>
                      <dl>
                        <dt>{{$i18nUtil.trans("message.HtagList.019","활성화")}}</dt>
                        <dd>
                          <div class="radio-box">
                            <input type="radio" name="active" id="active1" value="1" v-model="activeCheck"><label for="active1">{{$i18nUtil.trans("message.HtagList.007","활성")}}</label> 
                            <input type="radio" name="active" id="active2" value="0" v-model="activeCheck"><label for="active2">{{$i18nUtil.trans("message.HtagList.008","비활성")}}</label>
                          </div>
                        </dd>
                      </dl>
                    </li>
                    <li>
                      <dl>
                        <dt>{{$i18nUtil.trans("message.HtagList.009","태그등록")}}</dt>
                        <dd>
                          <div class="input-box">
                            <input type="text" required="required" :placeholder="$i18nUtil.trans('message.HtagList.010','태그명 입력')" v-model="addHtagName" @keyup.enter="addHtag()">
                            <button type="reset" class="input-txt-del" @click="addHtagName=''">{{$i18nUtil.trans("message.HtagList.004","입력 삭제")}}</button>
                          </div>
                        </dd>
                      </dl>
                    </li>
                  </ul>
                  <ul class="hash-tag-list">
                    <li v-for="(htag, idx) in htagList" :key="'htag_'+idx">
                        <div class="btn-tag active" @click="openUpdateTagName(htag, idx, $event)" v-show="!tagUpdateFlag || idx != tagIndex">
                            {{htag.htag}} 
                            <button type="button" @click.stop="deleteHtag(htag, idx)">x</button>
                        </div>
                        <div class="btn-tag active" v-show="tagUpdateFlag && idx == tagIndex">
                            <input type="text" class="ipt-tag" v-model="changeHtagName" @keyup.enter="enterKeyUp()">
                        </div>
                    </li>
                  </ul>  
                  <div class="footer">
                    <button type="button" class="btn-primary-medium black" @click="addNodeInfo">{{$i18nUtil.trans("button.add","추가")}}</button>
                    <button type="button" class="btn-primary-medium black" @click="saveNodeInfo">{{$i18nUtil.trans("button.save","저장")}}</button> 
                    <button type="button" class="btn-primary-medium black" @click="deleteNodeInfo">{{$i18nUtil.trans("button.delete","삭제")}}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import HtagJobGroup from "./HtagJobGroup";
import AuditSubTab from "./AuditSubTab";
import AuditTab from "./AuditTab";

export default {
    name: "tabs",
    props: ["modalInfo"],
    components: {
        HtagJobGroup,
        AuditSubTab,
        AuditTab
    },
    data() {
        return {
            dBHeight: {
                'min-height': (window.innerHeight - 154) + 'px',
            },

            jobGroupInfo : [],
            htagList : [],
            activeCheck : 1,
            searchCheck : 1,
            selectedJobGroup: null,
            selectedCategoryName: null,

            addHtagName: '',
            changeHtagName: '',
            tagUpdateFlag: false,
            selectedHtag: null,
            tagIndex: -1,
            jobGroupRoute : '',

            toastInfo: {
              obj: this.$toasted,
              message: "",
              options: {
                theme: "toasted-primary",
                position: "bottom-left",
                duration: 3000,
              },
            },
        };
    },
    beforeDestroy() { 
        window.removeEventListener('click', this.chkAroundClick);
    },
    computed: {
        ...mapState("tree", ["treeData"]),
        ...mapState("tree", ["selectedDepts"]),
    },
    methods: {
        ...mapActions("modals", ["showToast", "showModal"]),
        /* rest Call&CallBack Action */
        ...mapActions("restAction", ["COWORK_REST_ACTION"]),
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
        /* treeList setting */
        ...mapActions("tree", ["setOrgTree"]),
        ...mapMutations("tree", ["setSelectedDepts"]),
        selectNode(param) {
          let obj = this;
          let reqData = {
            url : "/api/copaper/tag/getHtagItems",
            method : "post",
            params : {
              htagCategoryId : param.node.id,
            }
          };

          obj.COWORK_REST_SIMPLE_ACTION(reqData)
          .then(function (res) {
            if (res.errorCode == null) {
              obj.jobGroupInfo = res.result.jobGroupRoute;
              if(obj.jobGroupInfo.length != 0 ){
                obj.selectedJobGroup = obj.jobGroupInfo[obj.jobGroupInfo.length-1];
                obj.setSelectedDepts(obj.selectedJobGroup);
              }
              obj.jobGroupRoute ='';
              obj.jobGroupInfo.forEach(function(element, idx ) {
                if(idx == obj.jobGroupInfo.length-1){
                  obj.jobGroupRoute += element.htagCategoryName ;
                  obj.selectedCategoryName = element.htagCategoryName;
                  obj.activeCheck = element.activeYn ? 1 : 0;
                  obj.searchCheck = element.searchYn ? 1 : 0;
                }else{
                  obj.jobGroupRoute += element.htagCategoryName +" > ";
                }
              });
              obj.htagList = res.result.htagList;
            }
          })
          .catch(function (err) {
            console.log(err);
          });
        },
        /* 추가 버튼 클릭 시 */
        addNodeInfo(){ 
          if(this.selectedJobGroup == null){
            this.showAlertDialog(this.$i18nUtil.trans("message.HtagList.011","하위에 추가할 상위 직군을 선택하세요"), null, { 
                width: "400px",
                // height: "148px",
            });
            return;
          }

          let reqData = {
            url : "/api/copaper/tag/insertJobGroup",
            method : "post",
            params : {
              parentHtagCategoryId : this.selectedJobGroup.htagCategoryId || "POSITION",
              htagCategoryName: this.selectedCategoryName,
              activeYn: this.selectedJobGroup.activeYn,
              searchYn: this.selectedJobGroup.searchYn,
              htagList: this.htagList,
              level : this.selectedJobGroup.level+1
            }
          };

          let obj = this;
          obj.COWORK_REST_SIMPLE_ACTION(reqData)
          .then(function (res) {
            if (res.errorCode == null) {
              obj.$refs.org.handleAddNodeInfo(res.result.addHtagCategory); 
              obj.toastInfo.message = obj.$i18nUtil.trans("message.HtagList.012","추가되었습니다");
              obj.showToast(obj.toastInfo);
            }
          })
          .catch(function (err) {
            console.log(err);
          });
        },
        /* 삭제 버튼 클릭 시 */
        deleteNodeInfo() {
          if(this.selectedJobGroup == null){
            this.showAlertDialog(obj.$i18nUtil.trans("message.HtagList.013","삭제 할 직군을 선택하세요"), null, {
                width: "400px",
                // height: "148px",
            });
            return;
          }

          if(this.selectedJobGroup.parentHtagCategoryId == null || this.selectedJobGroup.parentHtagCategoryId == ""){
            this.showAlertDialog(obj.$i18nUtil.trans("message.HtagList.014","최상위 직군은 삭제 할 수 없습니다"), null, {
                width: "400px",
                // height: "148px",
            });
            return;
          }

          let reqData = {
            url : "/api/copaper/tag/deleteJobGroup",
            method : "post",
            params : {
              htagCategoryId : this.selectedJobGroup.htagCategoryId,
              htagCount: this.htagList.length,
            }
          };
          
          let obj = this;
          obj.COWORK_REST_SIMPLE_ACTION(reqData)
          .then(function (res) {
            if (res.errorCode == null) {
              obj.$refs.org.handledeleteNodeInfo(obj.selectedJobGroup); 
              obj.toastInfo.message = obj.$i18nUtil.trans("message.HtagList.020","삭제되었습니다.");
              obj.showToast(obj.toastInfo);
              obj.jobGroupInfo = null;
              obj.selectedCategoryName = '';
            }
          })
          .catch(function (err) {
            console.log(err);
          });
        },
        /* 저장 버튼 클릭 시 */
        saveNodeInfo() {
          if(this.selectedJobGroup == null){
            this.showAlertDialog(this.$i18nUtil.trans("message.HtagList.015","수정 할 직군을 선택하세요"), null, {
                width: "400px",
                // height: "148px",
            });
            return;
          }

          let reqData = {
            url : "/api/copaper/tag/updateJobGroup",
            method : "post",
            params : {
              htagCategoryId: this.selectedJobGroup.htagCategoryId,
              htagCategoryName: this.selectedCategoryName,
              activeYn: this.selectedJobGroup.activeYn,
              searchYn: this.selectedJobGroup.searchYn
            }
          };
          let obj = this;
          obj.COWORK_REST_SIMPLE_ACTION(reqData)
          .then(function (res) {
            if (res.errorCode == null) {
              
              let location = obj.jobGroupRoute.substring( 0, obj.jobGroupRoute.lastIndexOf(">")+2 );
              obj.jobGroupRoute = location + obj.selectedCategoryName;

              obj.$refs.org.handleChangeNodeName(obj.selectedCategoryName); 
              obj.toastInfo.message = obj.$i18nUtil.trans("message.HtagList.016","저장되었습니다");
              obj.showToast(obj.toastInfo);
            }
          })
          .catch(function (err) {
            console.log(err);
          });
        },
        /* 태그 이름 변경 이벤트 리스너 등록. */
        openUpdateTagName(htag,idx, event){
          window.addEventListener('click', this.chkAroundClick);
          // event.target.classList.toggle('active');
          this.tagIndex = idx; 
          this.selectedHtag = htag;
        },
        /* click 이벤트 리스너 */
        chkAroundClick(event){
          if(this.tagUpdateFlag == true){
            if(event.target.classList[0] != "ipt-tag"){
              this.enterKeyUp();
            }
          }else{
            this.tagUpdateFlag = true;
          }
        },
        enterKeyUp(){
          this.tagUpdateFlag = false;
          this.tagIndex = -1;
          window.removeEventListener('click', this.chkAroundClick);
          
          if(this.changeHtagName != ""){
            // changeTagName 로직.
            this.selectedHtag.htag = this.changeHtagName;
            this.updateHtagName(this.selectedHtag);
            this.changeHtagName = '';
          }
        },
        /* 태그이름 수정 */
        updateHtagName(htag){
          if(htag.htag == ""){
            return;
          }

          let obj = this;
          let reqData = {
            url : "/api/copaper/tag/changeHtagName",
            method : "post",
            params : {
              htag : htag
            }
          };

          obj.COWORK_REST_SIMPLE_ACTION(reqData)
          .then(function (res) {
            // console.log(res);
            // obj.htagList = res.result.htagList;
          })
          .catch(function (err) {
            console.log(err);
          });
        },
        /* 태그 추가 */
        addHtag(){
          if(this.selectedJobGroup == null){
            this.showAlertDialog(this.$i18nUtil.trans("message.HtagList.017","태그를 추가 할 직군을 선택하세요"), null, {
                width: "400px",
                // height: "148px",
            });
            return;
          }

          if(this.addHtagName == ''){
            return;
          }

          let obj = this;
          let parentHtagCategoryId = '';
          obj.jobGroupInfo.forEach(function(element, idx ) {
            if(element.parentHtagCategoryId == 'POSITION'){
              parentHtagCategoryId = element.htagCategoryId;
            }
          });

          if(parentHtagCategoryId == ''){
            parentHtagCategoryId = 'POSITION';
             this.showAlertDialog(this.$i18nUtil.trans("message.HtagList.018","최상위 직군에는 태그를 추가할 수 없습니다."), null, {
                width: "400px",
                // height: "148px",
            });
            return;
          }

          let reqData = {
            url : "/api/copaper/tag/insertHtag",
            method : "post",
            params : {
              htagCategoryId: this.selectedJobGroup.htagCategoryId,
              rootId: parentHtagCategoryId,
              htagName: this.addHtagName
            }
          };

          obj.COWORK_REST_SIMPLE_ACTION(reqData)
          .then(function (res) {
            if (res.errorCode == null) {
              obj.htagList.splice(obj.htagList.length,0,res.result.insertHtag);
              obj.addHtagName = "";
            }
          })
          .catch(function (err) {
            console.log(err);
          });
        },
        /* 태그삭제 */
        deleteHtag(htag, idx){

          let obj = this;
          let reqData = {
            url : "/api/copaper/tag/deleteHtag",
            method : "post",
            params : {
              htagId : htag.htagId
            }
          };

          obj.COWORK_REST_SIMPLE_ACTION(reqData)
          .then(function (res) {
            if (res.errorCode == null) {
              obj.htagList.splice(idx,1);
            }
          })
          .catch(function (err) {
            console.log(err);
          });
        },
    },
};
</script>


// WEBPACK FOOTER //
// src/components/cowork/cosys/audit/base/tab/history/HtagList.vue